import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=0ac42ce6&scoped=true&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=ts&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac42ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac42ce6')) {
      api.createRecord('0ac42ce6', component.options)
    } else {
      api.reload('0ac42ce6', component.options)
    }
    module.hot.accept("./TextAreaComponent.vue?vue&type=template&id=0ac42ce6&scoped=true&", function () {
      api.rerender('0ac42ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/TextAreaComponent.vue"
export default component.exports